<cx-page-slot position="Section1"></cx-page-slot>
@if (userName) {
  <span class="welcome-msg">Hello {{userName}}!</span>
}
<cx-page-slot position="Section2"></cx-page-slot>
<cx-page-slot position="Section3"></cx-page-slot>
<cx-page-slot position="Section6"></cx-page-slot>
<div class="slideshow-container" >
  <cx-page-slot position="Section4" #carouselSopt> </cx-page-slot>
  @if (totalSlides > 0) {
    <div>
      <button class="carousel__prev-button" [disabled]="slideIndex === 1" (click)="plusSlides(-1)">
        <cx-icon [type]="previousIcon"></cx-icon>
      </button>
      <button
        class="carousel__next-button"
        [disabled]="slideIndex === totalSlides || totalSlides === 0"
        (click)="plusSlides(1)"
        >
        <cx-icon [type]="nextIcon"></cx-icon>
      </button>
    </div>
  }
</div>
@if (totalSlides > 0) {
  @if (dots.length > 0) {
    <div class="dots">
      @for (dot of dots; track dot; let i = $index) {
        <span
          class="dot"
          [ngClass]="{ active: i + 1 === slideIndex }"
          (click)="totalSlides > 1 && currentSlide(i + 1)"
        ></span>
      }
    </div>
  }
}
<cx-page-slot position="Section5"></cx-page-slot>
